import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';

import ThumbnailsToggle from '../../../components/Editor/ThumbnailsToggle';

const mapStateToProps = (state: StoreState) => {
	const {
		editor: {
			isThumbnailsDisplayed,
		},
	} = state;

	return {
		isOpened: isThumbnailsDisplayed,
	};
};

export default connect(mapStateToProps)(ThumbnailsToggle);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/ThumbnailsToggle/index.tsx